// React
import React from 'react';

// Pages
import Home from './pages/Home';

const routes = [
  {
    path: '/',
    element: <Home />,
    children: [
    ]
  }
];

export default routes;
